import { serializeTokens } from './tokens'
import { SerializedPoolConfig, PoolCategory } from './types'

const serializedTokens = serializeTokens()

const pools: SerializedPoolConfig[] = [
  // Manual Staking Pool (user stakes MONEY directly into MasterChef PID 0)
  {
    sousId: 10, // Manual pool uses MasterChef PID 0 directly
    stakingToken: serializedTokens.BESC,
    earningToken: serializedTokens.BESC,
    contractAddress: {
      420042: '0x51b46699dD3Ed282Cb65b348Ec207D703c5441a8', // This is the actual MasterChef address
    },
    poolCategory: PoolCategory.COMMUNITY,
    harvest: true,
    tokenPerBlock: '0.007', // adjust based on your real reward
    sortOrder: 1,
    isFinished: false,
    isAutoVault: false,
    startBlock: 2917308,
    endBlock: 3287494,

  },
]

export default pools
